import React, { useContext, useEffect, useState } from 'react';
import { useTheme } from '../../../contexts/ThemeContext';
import TopNavbar from './TopNavbar';
import SecondaryNavbar from './SecondaryNavbar';
import { getCompanyInfo } from '../../../services/companyService';

const Navbar = () => {
  const { theme, toggleTheme } = useTheme();
  const [companyInfo, setCompanyInfo] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadCompanyInfo = async () => {
      try {
        const data = await getCompanyInfo();
        setCompanyInfo(data);
      } catch (err) {
        console.error('Error fetching company info:', err);
        setError('Failed to load company information');
      }
    };

    loadCompanyInfo();
  }, []);

  if (error) {
    console.warn('Navbar loading with default values due to error:', error);
  }

  return (
    <header className="sticky top-0 z-50">
      <TopNavbar 
        theme={theme}
        socialLinks={companyInfo?.socialLinks || {}}
        contactInfo={companyInfo?.contactInfo || {}}
        onToggleTheme={toggleTheme}
      />
      <SecondaryNavbar
        theme={theme}
        companyInfo={companyInfo}
      />
    </header>
  );
};

export default Navbar;
